<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.subuser', 2) }}
          <v-btn color="primary" @click="addUserDialog = true"> {{ $t('add') }} </v-btn>
        </h1>
      </v-flex>

      <v-dialog v-model="addUserDialog" width="500">
        <v-card>
          <v-card-text>
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$t('attrs.email')"
              clearable
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="addUserDialog = false">
              {{ $t('close') }}
            </v-btn>

            <v-btn color="primary" flat @click="addUser">
              {{ $t('add') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      :total-items="totalItems"
                      :pagination.sync="pagination"
                      item-key="id"
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <tr @click="props.expanded = !props.expanded">
              <td>
                {{ props.item.sequential_id || props.item.id }}
              </td>
              <td> {{ props.item.fullname }} </td>
              <td> {{ props.item.email }} </td>
              <td class="pa-0 pr-2 text-xs-right">
                <v-btn color="red" flat icon @click="removeUser(props.item)">
                  <font-awesome-icon icon="times"></font-awesome-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import User from '@/client/user'
import Subuser from '@/client/subuser'

export default {
  name: "SubUsers",

  data () {
    return {
      headers: [
        { text: '#', align: 'left', sortable: true, value: 'id', width: '5%' },
        { text: this.$t('attrs.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('attrs.email'), align: 'left', sortable: true, value: 'email' },
        { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'created_at',
        descending: true
      },
      loading: false,

      search: '',
      addUserDialog: false,
    }
  },

  props: {
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      try {
        this.items = await Subuser.all({ user_id: this.$route.params.userId })
      } catch (e) {
        console.error(e)
      }
    },

    async addUser () {
      if (!this.search) { return }

      try {
        const users = await User.all({ where: { email: this.search } })
        if (users.length === 1) {
          const user = users[0]
          user.parent_id = this.$route.params.userId
          await user.update()
          this.fetch()
          this.addUserDialog = false
        } else {
          throw new Error('Usuario no encontrado!');
        }
      } catch (e) {
        this.handleErr(e)
      }
    },

    async removeUser (subuser) {
      try {
        const user = new User({ ...subuser })
        user.parent_id = null
        await user.update()
        this.fetch()
      } catch (e) {
        this.handleErr(e)
      }
    },
  },

  watch: {
  },

  mounted () {
    this.fetch()
  }
}
</script>
